// Web route segments auth owns under shared infrastructure
export const AuthWebRouteSegment = Object.freeze({
  // settings routes
  Account: "account",
  EmergencyAccess: "emergency-access",

  // settings/security routes
  /**
   * IMPORTANT: This `AuthWebRouteSegment.Password` route path must NOT contain the substring "change-password". The `authGuard`
   * uses a substring check (`url.includes("change-password")`) to exempt the forced `/change-password` route from redirection — a route
   * containing that substring would be incorrectly exempted. See PM-34258 for further explanation/future cleanup.
   */
  Password: "password",
  TwoFactor: "two-factor",
  SecurityKeys: "security-keys",
  DeviceManagement: "device-management",
} as const);

export type AuthWebRouteSegment = (typeof AuthWebRouteSegment)[keyof typeof AuthWebRouteSegment];

// Full routes that auth owns in the web app
export const AuthWebRoute = Object.freeze({
  SignUpLinkExpired: "signup-link-expired",
  RecoverTwoFactor: "recover-2fa",
  AcceptEmergencyAccessInvite: "accept-emergency",
  RecoverDeleteAccount: "recover-delete",
  VerifyRecoverDeleteAccount: "verify-recover-delete",
  AcceptOrgDirectInvite: "accept-organization",

  // Composed routes from segments (allowing for router.navigate / routerLink usage)
  AccountSettings: `settings/${AuthWebRouteSegment.Account}`,
  EmergencyAccessSettings: `settings/${AuthWebRouteSegment.EmergencyAccess}`,

  PasswordSettings: `settings/security/${AuthWebRouteSegment.Password}`,
  TwoFactorSettings: `settings/security/${AuthWebRouteSegment.TwoFactor}`,
  SecurityKeysSettings: `settings/security/${AuthWebRouteSegment.SecurityKeys}`,
  DeviceManagement: `settings/security/${AuthWebRouteSegment.DeviceManagement}`,
} as const);

export type AuthWebRoute = (typeof AuthWebRoute)[keyof typeof AuthWebRoute];
